import { format } from "date-fns";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AddVitalIcon, Spinner } from "../shared/svgIcon";
import { cn, dateConvert, useAppointmentsMiscellaneous } from "../shared/utils";
import {
  getDocuments,
  getDocumentsAvailableRange,
  getOrganizations,
  shareDocument,
  uploadDocument,
} from "../lib/api";
import { useStore } from "../store";
import { toast } from "sonner";
import { useQuery } from "@tanstack/react-query";
import { Dialog, DialogContent } from "./ui/dialog";

const DocumentHistory = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const type = new URLSearchParams(location.search).get("type");
  const from = new URLSearchParams(location.search).get("from");
  const selectedAppointment = useStore((state) => state.selectedAppointment);
  const setSelectedAppointment = useStore((state) => state.setAppointment);
  const setSelectedEcg = useStore((state) => state.setSelectedEcg);
  const { data: appointmentsMisc } = useAppointmentsMiscellaneous();
  const filetypes = appointmentsMisc?.data?.result?.document_file_types;
  const documentTypes = appointmentsMisc?.data?.result?.document_types;

  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [filterDoctype, setFilterDoctype] = useState("");

  const [uploadmodel, setUploadmodel] = useState(false);
  const [filetype, setfiletype] = useState("");
  const [doctype, setDoctype] = useState("");

  const [file, setFile] = useState(null);
  const [fileuploading, setFileuploading] = useState("false");
  const [shareEnable, setShareEnable] = useState(false);
  const [enableMultiShare, setEnableMultiShare] = useState(false);

  const [isDisableFilterDoctype, setDisableFilterDoctype] = useState(false);

  useEffect(() => {
    if (from == "share") {
      setShareEnable(true);
    }
  }, [from]);

  const goToEcg = (item) => {
    setSelectedEcg(item);
    // sessionStorage.setItem('currentEcg',JSON.stringify(item))
    navigate("/ecgView");
  };
  const goToDoc = (doc) => {
    // console.log(doc)
    // sessionStorage.setItem('currentEcg',JSON.stringify(item))
    navigate(`/documentView/${doc.id}`);
  };
  const goToHome = (index) => {
    navigate("/dashboard");
  };
  const handleGoBack = () => {
    navigate(-1);
  };

  const [documents, setDocuments] = useState([]);

  const [isLoading, setLoading] = useState(true);

  const getEcgInfo = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }

      setLoading(true);

      const res = await getDocuments({
        patientId,
        startDate: dateConvert(new Date(startDate)),
        endDate: dateConvert(new Date(endDate)),
        type: filterDoctype,
      });
      const result = res?.data?.result;
      const ecgDetails = result;
      if (ecgDetails) {
        setDocuments(ecgDetails);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    // console.log(e);
    setFile(e.target.files[0]);
    console.log(e.target.files[0]);
  };
  const documentupload = async () => {
    setFileuploading("true");
    const formData = new FormData();
    if (doctype != null && filetype != null) {
      var id = localStorage.getItem("patientId");
      formData.append("consumer_id", id);
      formData.append("file", file);
      formData.append("upload_type", "aws_s3");
      formData.append("doc_type", doctype);
      formData.append("file_type", filetype);
      formData.append(
        "source",
        JSON.stringify({
          identifier: "654cc54350349ba664618567",
          classification: "kiosk",
          location: "trivandrum",
          name: "lulu",
        })
      );

      // console.log(formData);
      const res = await uploadDocument(formData);
      if (res?.message == "successfully completed") {
        if (res?.data?.result?.inference_details?.image) {
          sessionStorage.removeItem("currentEcg");
          navigate("/ecgView");
        }
        setUploadmodel(false);
        setFileuploading("false");
      } else {
        setFileuploading("false");
      }
    } else {
      setFileuploading("Select all options");
    }
  };
  const getFilterDate = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }
      setLoading(true);
      const limit = 5;
      const res = await getDocumentsAvailableRange(patientId, limit);
      const result = res?.data?.result;
      // console.log(result, "result");

      if (result) {
        setStartDate(new Date(result?.start_date).toISOString());
        setEndDate(new Date(result?.end_date).toISOString());
      }

      // setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const setInitialState = async () => {
    if (type) {
      setFilterDoctype(type);
      setDisableFilterDoctype(true);
    }
    await getFilterDate();
  };

  const handleStartDateChange = (event) => {
    const newStartDate = event.target.value;
    setStartDate(newStartDate);

    // Perform any other actions you need with the new start date
    // console.log("New Start Date:", newStartDate);
  };
  const handleEndDateChange = (event) => {
    const newEndDate = event.target.value;
    setEndDate(newEndDate);

    // Perform any other actions you need with the new start date
    // console.log("New end Date:", newEndDate);
  };
  useEffect(() => {
    setInitialState();
  }, [location]);

  useEffect(() => {
    if (startDate && endDate) {
      getEcgInfo();
    }
  }, [startDate, endDate, filterDoctype]);

  useEffect(() => {
    if (filetypes?.length > 0) {
      setfiletype(filetypes[0].value);
    }
  }, [filetypes]);
  useEffect(() => {
    if (documentTypes?.length > 0) {
      setDoctype(documentTypes[0].value);
    }
  }, [documentTypes]);

  const getBackground = (key) => {
    const background_gradient = [
      "linear-gradient(180deg,rgba(255,232.69,252.77,0.5) 0%,rgba(255,214.62,250.96,0.5) 100%)",
      "linear-gradient(180deg,rgba(228.28,249.69,227.84,0.5) 0%,rgba(211.42,253.94,210.56,0.5) 100%)",
      "linear-gradient(180deg,rgb(249.69,248.81,227.84) 0%,rgb(248.63,245.52,170.93) 100%)",
      "linear-gradient(180deg,rgb(245.44,248.11,255) 0%,rgb(210.56,222.7,253.94) 100%)",
      "linear-gradient(180deg,rgba(255,235.96,225.25,0.5) 0%,rgba(255,215.56,193.37,0.5) 100%)",
      "linear-gradient(180deg,rgba(238,255,251.94,0.5) 0%,rgba(183.28,239.06,232.37,0.5) 100%)",
    ];
    const index = documentTypes?.findIndex((e) => e.key == key);

    return background_gradient[index];
  };

  const selectedPatient = useStore((state) => state.patient);
  const [availableHospitals, setAvailableHospital] = useState([]);
  const [selectedHospitals, setSelectedHospital] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState([]);

  const {
    data: selectedHospitalListRes,
    isLoading: isLoadingHospital,
    dataUpdatedAt,
  } = useQuery({
    queryKey: ["selectedHospitalList"],
    queryFn: () => getOrganizations(selectedPatient?.id),
    enabled: !!selectedPatient?.id,
    refetchOnMount: true,
  });

  useEffect(() => {
    const currentHospitals =
      selectedHospitalListRes?.data?.result?.map((e) => ({
        ...e.organization,
        isActive: false,
      })) || [];
    // console.log(currentHospitals, "currentHospitals");
    setAvailableHospital([...currentHospitals]);
  }, [dataUpdatedAt, selectedHospitalListRes]);

  const handleHospitalClick = (hospital) => {
    const isSelected = selectedHospitals?.some(
      (selected) => selected.id === hospital.id
    );
    if (isSelected) {
      const isActive = selectedHospitals?.filter(
        (selected) => selected.id === hospital.id
      )[0].isActive;
      if (isActive) return;
    }

    const updatedHospital = isSelected
      ? selectedHospitals?.filter((selected) => selected.id !== hospital.id)
      : [...selectedHospitals, hospital];
    // console.log(updatedHospital, "updatedHospital");
    setSelectedHospital(updatedHospital);
  };

  const handleDocumentSharing = async (payload) => {
    const response = await shareDocument(payload);
    return response;
  };

  const shareDocumentWithHospital = async () => {
    for (const document of selectedDocs) {
      for (const hospital of selectedHospitals) {
        const payload = {
          document_id: document.id,
          organization_id: hospital.id,
          permissions: {
            read: true,
            write: false,
            share: false,
            delete: false,
          },
          is_active: true,
        };
        // console.log(payload);

        try {
          const response = await handleDocumentSharing(payload);
          if (response?.isSuccess) {
            toast("Document shared successfully with " + hospital.name);
          } else {
            toast("Failed to share document with " + hospital.name);
            // Handle failure case if necessary
          }
        } catch (error) {
          console.error("Error occurred while sharing document:", error);
          // Handle error
        }
      }
    }
    setIsDialogOpen(false);
    setEnableMultiShare((prev) => !prev);
    setSelectedDocs([]);
  };

  const shareDocumentWithAppointment = async (document) => {
    // console.log(document, "document");
    const payload = {
      document_id: document?.id,
      shared_with:
        selectedAppointment?.user?.id || selectedAppointment?.user_id,
      organization_id:
        selectedAppointment?.organization?.id ||
        selectedAppointment?.organization_id,
      permissions: {
        read: true,
        write: false,
        share: false,
        delete: false,
      },
      is_active: true,
    };
    const response = await handleDocumentSharing(payload);

    // console.log(payload, "payload", response);
    if (response?.isSuccess) {
      updateSelectedAppointment(document?.id);
      toast("Document shared successfully.");
      navigate(-1);
    }
  };

  const updateSelectedAppointment = (documentId) => {
    setSelectedAppointment({
      ...selectedAppointment,
      documents: selectedAppointment?.documents
        ? [...selectedAppointment?.documents, documentId]
        : [documentId],
    });
  };

  const handleShareDocument = (event, document) => {
    event.stopPropagation();

    if (selectedAppointment) {
      shareDocumentWithAppointment(document);
    } else {
      setSelectedDocs((prevDocuments) => [...prevDocuments, document]);
      setIsDialogOpen(true);
    }
  };

  const updateSelectedDocs = (doc) => {
    // setSelectedDocs((prevDocuments) => [...prevDocuments, doc]);
    const isSelected = selectedDocs?.some((selected) => selected.id === doc.id);
    if (isSelected) {
      const isActive = selectedDocs?.filter(
        (selected) => selected.id === doc.id
      )[0].isActive;
      if (isActive) return;
    }

    const updatedVitals = isSelected
      ? selectedDocs?.filter((selected) => selected.id !== doc.id)
      : [...selectedDocs, doc];
    // console.log(updatedVitals, "updatedVitals");
    setSelectedDocs(updatedVitals);
  };
  const handleMultiShare = () => {
    setEnableMultiShare((prev) => !prev);
    setSelectedDocs([]);
  };

  const DocumentCard = ({
    doc,
    goToEcg,
    goToDoc,
    shareEnable,
    handleShare,
  }) => {
    const isImageStream = doc?.inference?.image_stream ? true : false;

    return (
      <div
        style={{
          // borderColor: e?.style?.border,
          background: getBackground(doc.doc_type),
        }}
        className="w-full rounded-xl border-2 bg-gradient-to-r bg-violet-100 border-indigo-300 text-center flex flex-col py-4  font-semibold text-lg"
        onClick={(e) => {
          e.stopPropagation();
          if (enableMultiShare) {
            updateSelectedDocs(doc);
          }
        }}
      >
        <div className="flex justify-between items-center w-full px-4">
          <p className="flex font-semibold text-base capitalize">
            {enableMultiShare && (
              <input
                type="checkbox"
                className="border-gray-300 rounded h-5 w-5 text-blue-500 bg-blue-100 focus:ring-blue-500 mr-4 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  updateSelectedDocs(doc);
                }}
                checked={selectedDocs.some(
                  (selected) => selected.id === doc.id
                )}
                readOnly
              />
            )}
            {doc.doc_type}
          </p>
          {doc.created_date && (
            <div className="flex px-4 py-2 border rounded-full text-sm border-green-300">
              <p>{format(new Date(doc.created_date), "dd/MM/yyyy, h:mm a")}</p>
            </div>
          )}
        </div>
        <div className="flex flex-col w-full h-full px-4 ">
          {isImageStream ? (
            <div
              className="flex flex-col pt-4 cursor-pointer"
              onClick={() => {
                if (enableMultiShare) {
                  updateSelectedDocs(doc);
                } else {
                  goToEcg(doc);
                }
              }}
            >
              <img
                src={`data:image/jpeg;base64,${doc?.inference?.image_stream}`}
                alt="ecg"
                className="object-contain h-[80px]"
              />
              <div className="flex justify-between w-full  pt-4 ">
                <InfoItem
                  label="Scale mm/s"
                  value={doc?.inference?.extras?.scale_mm_per_s || "-"}
                />
                <InfoItem
                  label="Scale mm/mV"
                  value={doc?.inference?.extras?.scale_mm_per_mV || "-"}
                />
                <InfoItem
                  label="MF"
                  value={doc?.inference?.extras?.mains_frequency || "-"}
                />
              </div>
              {shareEnable && (
                <div className="flex justify-end items-center w-full pt-3 px-4 gap-4">
                  <button
                    className="h-10 rounded-[12px] border-2 border-blue-800 py-2 px-4 text-center text-blue-800 text-lg leading-none"
                    onClick={(event) => handleShare(event, doc)}
                  >
                    Share
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <div className="border-b-2 mt-2 w-full"></div>
              <div className="flex flex-col justify-between w-full h-full pt-4 ">
                <div className="flex flex-col">
                  <p className="flex font-semibold text-sm items-start">
                    fileType
                  </p>
                  <div className="flex font-semibold text-sm items-start">
                    {doc.file_type}
                  </div>
                </div>

                <div className="flex justify-end items-center w-full pt-3 px-4 gap-4">
                  <button
                    className="whitespace-nowrap h-10 rounded-[12px] border-2 border-blue-800 py-2 px-4 text-center text-blue-800 text-lg leading-none"
                    onClick={() => goToDoc(doc)}
                  >
                    View Document
                  </button>
                  {shareEnable && (
                    <button
                      className="h-10 rounded-[12px] border-2 border-blue-800 py-2 px-4 text-center text-blue-800 text-lg leading-none"
                      onClick={(event) => handleShare(event, doc)}
                    >
                      Share
                    </button>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const InfoItem = ({ label, value }) => (
    <div className="flex flex-col">
      <p className="flex font-semibold text-sm items-start">{label}</p>
      <div className="flex font-semibold text-sm items-start">{value}</div>
    </div>
  );

  return (
    <div className="bg-gray-50 sh-screen">
      <div className="flex flex-col text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 ">
        <div>
          <Link className="flex" onClick={handleGoBack}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            <div className="pl-2 flex-1 mt-0.5">
              <h4 className="font-semibold text-sm">Document History</h4>
            </div>
          </Link>
        </div>
        <div
          className={` p-2  pt-4 flex flex-col sm:flex-row  sm:gap-4 ${
            (isDisableFilterDoctype  && shareEnable) ? "justify-end" : "justify-between"
          }`}
        >
          
            <div className={`${shareEnable ? "" : "flex flex-row gap-3"}`}>
              {/* <div className="font-bold py-2">Document Type</div> */}
              {!shareEnable && (
                <button
                  className="h-10 rounded-[12px] border-2 bg-blue-800 py-2 px-4 text-center text-white text-lg leading-none"
                  onClick={() => handleMultiShare()}
                >
                  {enableMultiShare ? "Cancel" : "Share"}
                </button>
              )}
              {!isDisableFilterDoctype && (<select
                className="p-2 mb-5 border bg-gray-50 rounded-lg w-full"
                value={filterDoctype}
                onChange={(e) => setFilterDoctype(e.target.value)}
              >
                <option value="">Select Type</option>
                {documentTypes?.map((e, index) => (
                  <option key={index} value={e.key}>
                    {e?.value}
                  </option>
                ))}
              </select>
               )}
            </div>
         
          <div className="flex">
            <div className="text-xs mt-1 relative ">
              <input
                type="date"
                defaultValue={startDate?.split("T")[0]}
                onChange={handleStartDateChange}
                className="bg-primary text-white w-24 p-1 rounded-lg text-center"
              />
            </div>
            <div className="px-2 mt-1">to</div>
            <div className="text-xs mt-1 relative">
              <input
                type="date"
                defaultValue={endDate?.split("T")[0]}
                onChange={handleEndDateChange}
                className="bg-primary text-white w-24 p-1 rounded-lg text-center"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className={` pb-1 px-4 ${
          (isDisableFilterDoctype  && shareEnable)  ? "pt-28" : "pt-44 sm:pt-28"
        }`}
      >
        <div
          className={` flex-1 overflow-scroll hideScroll  flex flex-col ${
            (isDisableFilterDoctype  && shareEnable)
              ? "h-[calc(100vh-180px)]"
              : "h-[calc(100vh-250px)] sm:h-[calc(100vh-180px)]"
          }`}
        >
          {documents.length > 0 && !isLoading && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  gap-3 md:gap-3 sm:justify-normal">
              {documents.map((doc, index) => (
                <DocumentCard
                  key={index}
                  doc={doc}
                  goToEcg={goToEcg}
                  goToDoc={goToDoc}
                  shareEnable={shareEnable}
                  handleShare={handleShareDocument}
                />
              ))}
            </div>
          )}
          {documents.length == 0 && !isLoading && (
            <div className=" flex flex-col  items-center flex-1">
              <div>
                <AddVitalIcon width={"100px"} height={"200px"} />
              </div>
              <h1 className="text-xl font-bold">No Data</h1>
              <p className="text-gray-400 text-base font-semibold m-4">
                Please Add Your Health Information
              </p>
              <button
                className={cn(
                  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                  "bg-secondary text-primary-foreground shadow hover:opacity-40",
                  "h-10 rounded-md px-8"
                )}
                onClick={goToHome}
              >
                Go Home
              </button>
            </div>
          )}
          {isLoading && (
            <div className=" relative ">
              <div className=" gap-3 md:gap-3 flex-wrap flex-1  sm:justify-normal grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                {" "}
                <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                  <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                  <div className="flex flex-col w-full">
                    <div className="m-2 w-full  bg-slate-200 h-4"></div>
                    <div className="m-2  w-full  bg-slate-200 h-4"></div>
                  </div>
                </div>
                <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                  <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                  <div className="flex flex-col w-full">
                    <div className="m-2 w-full  bg-slate-200 h-4"></div>
                    <div className="m-2  w-full  bg-slate-200 h-4"></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-white h-16 fixed flex justify-center bottom-0 w-full">
        {selectedDocs.length == 0 || !enableMultiShare ? (
          <button
            className="w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold"
            onClick={() => setUploadmodel(!uploadmodel)}
          >
            New
          </button>
        ) : (
          <button
            className="w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold"
            onClick={(e) => setIsDialogOpen(true)}
          >
            {selectedDocs.length} Share
          </button>
        )}
      </div>
      {uploadmodel && (
        <div className="fixed z-50 bottom-0 pb-20 p-4 pt-7 bg-white w-full rounded-t-3xl shadow-xl">
          <div className="relative flex flex-col ">
            <button
              className="absolute right-0 bg-blue-900 text-white px-1.5 rounded-full transition-all"
              onClick={() => setUploadmodel(!uploadmodel)}
            >
              ✕
            </button>
            <div className="text-lg text-blue-800 pb-3 font-bold">
              Upload Document
            </div>
            <div className="font-bold py-2">Upload Type</div>
            <select
              className="p-2 mb-5 border bg-gray-50 rounded-lg"
              value={filetype}
              onChange={(e) => setfiletype(e.target.value)}
            >
              {filetypes?.map((e, index) => (
                <option key={index} value={e.key}>
                  {e?.value}
                </option>
              ))}
              {/* <option value="pdf">PDF</option>
              <option value="jpg">JPG</option>
              <option value="png">PNG</option> */}
            </select>

            <div className="font-bold py-2">Document Type</div>
            <select
              className="p-2 mb-5 border bg-gray-50 rounded-lg"
              value={doctype}
              onChange={(e) => setDoctype(e.target.value)}
            >
              {documentTypes?.map((e, index) => (
                <option key={index} value={e.key}>
                  {e?.value}
                </option>
              ))}
              {/* <option value="ecg">ECG Report</option>
              <option value="doctor report">Doctor Report</option>
              <option value="pharmacy">Pharmacy Report</option>
              <option value="lab report">Lab Report (Blood Test)</option>
              <option value="other">Other Report</option> */}
            </select>
            <div className="relative p-5 py-7 text-center bg-gray-100">
              {file != null ? (
                <>
                  <div className="text-blue-700">
                    {file.name} <span className=" font-bold">Selected</span>
                  </div>
                  <div className="font-bold">Select another file</div>
                </>
              ) : (
                <>
                  <div>Upload your document here</div>
                  <div className="font-bold">File type PDF,JPG and PNG</div>
                </>
              )}
              <input
                type="file"
                className="absolute top-0 w-full p-7 left-0 opacity-0"
                onChange={(e) => handleFileChange(e)}
              ></input>
            </div>
            <div className="text-center">
              {file != null ? (
                <button
                  className="px-6 py-2 mt-2 rounded-full bg-blue-900 text-white"
                  onClick={() => documentupload()}
                >
                  Upload
                  {fileuploading == "true" && (
                    <Spinner className="ml-2 -mt-1 h-4 w-4 animate-spin inline-block" />
                  )}
                </button>
              ) : (
                <button className="px-6 py-2 mt-2 rounded-full bg-gray-200 text-white">
                  Upload
                </button>
              )}
              {fileuploading == "Select all options" && (
                <div className="text-red-500 font-semibold">
                  Select all options before continuing
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-[60%] max-w-[90%]">
          <div className="grid mt-4  gap-2 relative">
            <div className="flex flex-col justify-end  w-full sm:w-1/3 "></div>
            <div className=" flex-1 h-[calc(100vh-50vh)] overflow-scroll hideScroll  text-gray-500  flex flex-col pt-2  pb-4">
              {availableHospitals.length > 0 && !isLoading && (
                <div className="flex flex-col gap-3 flex-wrap">
                  {availableHospitals.map((hospital, index) => (
                    <div
                      className={`w-full flex flex-1 items-start space-x-3 py-4 px-2 bg-[#F5F5F5] text-[#32365C] rounded-[18px] border shadow cursor-pointer ${
                        selectedHospitals.some(
                          (selected) => selected.id === hospital.id
                        )
                          ? "border-primary"
                          : ""
                      }`}
                      key={index}
                      onClick={(e) => {
                        handleHospitalClick(hospital);
                      }}
                    >
                      <input
                        type="checkbox"
                        className="border-gray-300 rounded h-5 w-5 min-w-[20px] text-blue-500 bg-blue-100 focus:ring-blue-500 "
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent click event from bubbling to parent div
                          handleHospitalClick(hospital);
                        }}
                        checked={selectedHospitals.some(
                          (selected) => selected.id === hospital.id
                        )}
                        readOnly // Prevent checkbox from being editable by user
                      />

                      <div className="flex flex-col">
                        <div className="relative w-full">
                          <img
                            src={hospital?.logo_url}
                            alt={hospital?.name}
                            className="h-12 object-contain"
                          />
                        </div>
                        <h1 className="text-gray-700 font-medium leading-none">
                          {hospital.name}
                        </h1>
                        <p className="text-xs text-gray-500 mt-2 leading-4">
                          <span className="pr-2">
                            {hospital?.address?.street},
                          </span>
                          <span className="pr-2">
                            {hospital?.address?.city},
                          </span>
                          <span className="pr-2">
                            {hospital?.address?.state}
                          </span>
                          <span className="pr-2">
                            {hospital?.address?.postal_code}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {availableHospitals.length == 0 && !isLoading && (
                <h1 className="mt-4">No Hospitals found</h1>
              )}
              {isLoading && (
                <div className="flex flex-col gap-3 flex-wrap ">
                  {" "}
                  <div className="animate-pulse flex flex-row cursor-pointer p-4  w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                    <div className="w-full">
                      <div className="m-2 w-full  bg-slate-200 h-4"></div>
                    </div>
                  </div>
                  <div className="animate-pulse flex flex-row cursor-pointer p-4  w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                    <div className="w-full">
                      <div className="m-2 w-full  bg-slate-200 h-4"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              className="bg-white  w-full flex justify-center"
              onClick={() => shareDocumentWithHospital()}
            >
              <button className="  w-11/12  p-3 bg-blue-800 rounded-[18px] text-white font-semibold">
                share
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DocumentHistory;
